import React, { useState, useEffect } from "react";
import { IconButton, Tooltip, Box } from "@mui/material";
import InstallIcon from "@mui/icons-material/GetApp";

const PwaInstallPrompt = () => {
  const [showInstallPrompt, setShowInstallPrompt] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const isStandalone = window.matchMedia("(display-mode: standalone)").matches;

    const handleBeforeInstallPrompt = (event) => {
      if (!isStandalone) {
        event.preventDefault();
        setDeferredPrompt(event);
        setShowInstallPrompt(true);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, []);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.finally(() => {
        setDeferredPrompt(null);
        setShowInstallPrompt(false);
      });
    }
  };

  if (!showInstallPrompt) return null;

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 100,
        right: 16,
        zIndex: 1600,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <Tooltip title="Install App" arrow>
        <IconButton
          onClick={handleInstallClick}
          sx={{
            backgroundColor: "#4caf50",
            color: "#fff",
            borderRadius: "50%",
            padding: 1.5,
            boxShadow: 3,
            transition: "transform 0.2s ease",
            "&:hover": {
              transform: "scale(1.1)",
              backgroundColor: "#388e3c",
            },
          }}
        >
          <InstallIcon fontSize="medium" />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default PwaInstallPrompt;
